import { FC } from 'react'
import { useTranslation } from 'next-i18next'
import { IUserBase } from '@/types'
import { ProfileCard } from '@/components/molecules/ProfileCard'
import { getUserAvatar } from '@/utils'
import styles from './index.module.scss'

type Props = {
  item: IUserBase
}

export const JobSeekerCard: FC<Props> = ({ item }) => {
  const { t } = useTranslation(['companies-users-[id]'])

  return (
    <ProfileCard
      avatar={getUserAvatar(item)}
      name={item.name}
      jobHuntingStatus={item.profile.jobHuntingStatus}
      href={`/users/${item.username}`}
      isVerifiedAccount={item.profile.isVerifiedAccount}
    >
      <div className={styles.tag}>
        <img src='/images/common/job_title_icon.svg' alt='Project categories icon' className={styles.image} />
        {t(item.profile.primaryJobCategory.name)}
      </div>
      <div className={styles.tag}>
        <img
          src='/images/common/years_of_experience_icon.svg'
          alt='Years of experience icon'
          className={styles.image}
        />
        {t(item.profile.yearsOfExperience)}
      </div>
      <p className={styles.text}>{item.profile.bio}</p>
    </ProfileCard>
  )
}
